export const formatTitleForUrl = (title) => {
    return title
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^\u0600-\u06FF\w-]/g, ''); // Keep Arabic, English, numbers, and hyphens
};
